(function()
{
	// Library depencencies
	var DebugOptions = include('springroll.DebugOptions', false),
		TitleState = include('Lemonade.TitleState'),
		IntroState = include('Lemonade.IntroState'),
		KitchenState = include('Lemonade.KitchenState'),
		OutsideState = include('Lemonade.OutsideState'),
		OutroState = include('Lemonade.OutroState'),
		Application = include('springroll.Application'),
		Transition = include('lib.Transition'),
		Container = include('createjs.Container'),
		Bitmap = include('createjs.Bitmap'),
		Display = include('springroll.easeljs.EaselJSDisplay');

	var Lemonade = function()
	{
		Application.call(this, {
			fps: 60,
			name: 'Lemonade',
			state: 'title',
			// state: 'outside',
			canvasId: 'stage',
			configPath: 'assets/config/config.json',
			manifestsPath: 'assets/config/manifests.json',
			captionsPath: 'assets/config/captions.json',
			transition: new Transition(),
			transitionSounds: {
				"in": "ses-lem_play_lem-trans-on",
				"out": "ses-lem_play_lem-trans-off"
			},
			display: Display,
			displayOptions:	{
				clearView: true,
				mouseOverRate: 15
			}
		});

		this.onResize = this.onResize.bind(this);
		
		//set up listeners for initialization
		this.once("configLoaded", onConfigLoaded.bind(this));
		this.once("init", onInit.bind(this));

		this.onWindowUnload = this.onWindowUnload.bind(this);
		window.addEventListener("unload", this.onWindowUnload);
	};

	var p = extend(Lemonade, Application);

	p.onWindowUnload = function()
	{
		window.removeEventListener("unload", this.onWindowUnload);
		
		this.destroy();//destroy the game
	};

	var onConfigLoaded = function(config, assets)
	{
		
		//force a resize now to ensure that the game doesn't think it is 1024x660
		this.triggerResize();

		// add cursor assets for desktop
		if(!this.hasTouch) {
			assets.push(this.config.assets.cursor[0]); // default cursor
			assets.push(this.config.assets.cursor[1]); // rollover cursor
		}

		assets.push({
			"id": "QuitButton",
			"src": "assets/images/UI/closebutton.png"
		});

		app.globalState = app.config.globalState;
		app.globalState.startTime = Date.now();
		// app.loadLanguage("en");
	};

	var onInit = function()
	{
		this.cursor = null;
		var display = this.display;
		var canvas = display.canvas;

		// Add transition to the stage
		var transition = this.options.transition = new lib.Transition();
		transition.framerate = 30;
		//set a strict size that the transition represents
		transition.width = 1320;
		transition.height = 780;
		//remove the nominal bounds, as we don't want to use it
		transition.nominalBounds = null;

		//Create the calling from the configuration
		//This will only scale items on the root of the stage
		this.scaling.addItem(transition,
			{
				x:(1024-1320)/2,
				y:(660-780)/2,
				titleSafe:true,
				align:"top-left"
			});
		this.scaling.enabled = true;
		
		this.on("resize", this.onResize, -1);

		var assets = this.config.assets;
		var scaling = this.config.scaling;
		var fla = this.manifests;

		// Set the states to use
		this.states = {
			title: new TitleState({
				next: 'intro',
				preload: assets.title,
				scaling: scaling.title
			}),
			intro: new IntroState({
				next: 'kitchen',
				preload: assets.intro,
				scaling: scaling.intro
			}),
			kitchen: new KitchenState({
				next: 'outside', 
				previous: 'intro',
				preload: assets.kitchen,
				scaling: scaling.kitchen
			}),
			outside: new OutsideState({
				next: 'outro', 
				previous: 'kitchen',
				preload: assets.outside,
				scaling: scaling.outside
			}),
			outro: new OutroState({
				next: 'title', 
				previous: 'outside',
				preload: assets.outro,
				scaling: scaling.outro
			})
		};

		var stage = display.stage;

		/*if (global_doNotDisplayClose === false) {
			this.quitButton = new Bitmap(app.assetManager.cache.read("QuitButton"));
			this.onQuitTap = this.onQuitTap.bind(this);
			this.quitButton.addEventListener("click", this.onQuitTap);
			this.quitButton.regX = 28;
			this.quitButton.regY = 28;
			// this.quitButton.x = 500;

			this.scaling.addItem(this.quitButton,
			{
				x:980,
				y:80,
				// titleSafe:true,
				align:"top-right"
			});

			stage.addChild(this.quitButton);
		}*/

		// add and bind cursor
		if(!this.hasTouch)
		{
			stage.addEventListener("mouseleave", this.stageOut.bind(this));
			stage.addEventListener("mouseenter", this.stageIn.bind(this));
			stage.addEventListener("stagemousemove", this.onMouseMove.bind(this));
			stage.addEventListener("changecursor", this.onCursorChange.bind(this));
			//hide default cursor to show sesame star cursor
			this.display.canvas.style.cursor = "none";
			//Create the cursor
			this.cursor = new Container();

			this.cursorDefault = new Bitmap(app.assetManager.cache.read("CursorDefault"));
			this.cursor.addChild(this.cursorDefault);
			this.cursorPointer = new Bitmap(app.assetManager.cache.read("CursorOver"));
			this.cursor.addChild(this.cursorPointer);
			this.cursorPointer.visible = false;
			this.cursorDefault.regX = 18;
			this.cursorDefault.regY = 18;
			this.cursorPointer.regX = 18;
			this.cursorPointer.regY = 18;
			stage.addChild(this.cursor);
			this.currentDragged = this.currentDraggedOffset = null;
		}

		this.display.visible = true;
	};

	p.loadLanguage = function(language){
		// set new language
		app.globalState.language = language;

		// unload existing contexts
		if (this.sound.contextExists("vo")){
			this.sound.unload(app.config.sounds.vo);
		}

		// point the path in the vo config file to the localized files
		app.globalState.language = language;
		app.config.sounds.vo.path = "assets/sound/vo/" + app.globalState.language + "/";

		// add new vo context
		this.sound.addContext(app.config.sounds.vo);
	};

	p.onResize = function(w, h)
	{
		//tells the container element what size to be for proper placement
		//due to absolute/relative positioning stuff
		var container = document.getElementById("container");
		if(container.scrollIntoViewIfNeeded)
			container.scrollIntoViewIfNeeded(true);
	};

	// Log out the qeury options
	/*if (DEBUG && DebugOptions)
	{
		DebugOptions
			.string('state', 'title, game')
			.boolean('mute', 'mute all sounds')
			.log();
	}*/

	p.stageIn = function()
	{
		if(this.cursor) {
			this.cursor.visible = true;
		}
	};

	p.stageOut = function()
	{
		// if(this.cursor) {
		// 	this.cursor.visible = false;
		// }
	};
	
	p.onCursorChange = function(ev)
	{
		this.cursorPointer.visible = ev.cursor == "pointer";
		this.cursorDefault.visible = ev.cursor != "pointer";
	};
	
	p.onMouseMove = function(ev)
	{
		this._lastStageX = ev.stageX;
		this._lastStageY = ev.stageY;
		
		if(this.currentDragged) {
			return;
		}
		
		this.cursor.x = ev.stageX;
		this.cursor.y = ev.stageY;
	};

	p.onQuitTap = function()
	{
		window.close();
	};

	p.destroy = function()
	{
		var timeInSeconds = Math.round((Date.now() - app.globalState.startTime) / 1000);
		GTM_obj.trackGTMEvent("gameQuit", {'duration' : timeInSeconds});
		
		this.onWindowUnload = null;
		/*if(this.quitButton)
			this.quitButton.removeEventListener("click", this.onQuitTap);
		this.quitButton = null;*/
		
		Application.prototype.destroy.call(this);
	};

	// Give window access to the app
	window.app = new Lemonade();

}());
